import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-primary px-4 py-2 text-uppercase",
    type: "button",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleBack()), ["prevent"]))
  }, _toDisplayString(_ctx.t(_ctx.text)), 1))
}